<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		size?: 'sm' | 'md';
		children: Snippet;
	}

	const { size = 'md', children }: Props = $props();
</script>

<div class="icon {size}">
	{@render children()}
</div>

<style>
	.icon {
		flex-shrink: 0;

		&.sm :global(img) {
			height: var(--icon-lg);
			width: var(--icon-lg);
		}

		&.md :global(img) {
			margin-bottom: -0.2rem;
			height: var(--icon-xl);
			width: var(--icon-xl);
		}

		:global(img) {
			vertical-align: bottom;
		}
	}
</style>
